import React, { SetStateAction, useEffect } from 'react';
import Link from 'next/link';
import { HeaderDropdownData as dropdownData } from 'components/Header/Header.data';
import styles from './ProfileDropdown.module.css';

type ProfileDropdownProps = {
  show: boolean;
  showLogoutModal: () => void;
  bell?: boolean;
  setShowDropdown: (show: SetStateAction<boolean>) => void;
  children?: React.ReactNode;
  className?: string;
};

const ProfileDropdown = ({
  show,
  setShowDropdown,
  showLogoutModal,
  bell,
  children,
  className,
}: ProfileDropdownProps) => {
  useEffect(() => {
    if (show) {
      window.addEventListener('scroll', hideDropdown, { passive: true });
      return () => window.removeEventListener('scroll', hideDropdown);
    }
  }, [show]);

  const hideDropdown = () => {
    setShowDropdown(false);
  };

  return (
    <div className={`${styles.dropdown} ${className || ''}`}>
      <ul className={styles.dropdown__list}>
        {children ? (
          children
        ) : (
          <>
            {dropdownData.map((item) => (
              <Link href={item.src} key={item.src}>
                <a>
                  <li className={styles.dropdown__item} data-qa-marker={item.qaMarker}>
                    {item.text.replace('&nbsp;', '\u00A0')}
                    {item.bell && bell ? <div className={styles.dropdown__bell} /> : null}
                  </li>
                </a>
              </Link>
            ))}
            <li
              onClick={showLogoutModal}
              className={styles.dropdown__item}
              data-qa-marker="logout_btn"
            >
              Выход
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default ProfileDropdown;
